<div class="header">
  <inf-actions-bar
    [title]="title"
    [actions]="actions"
    [config]="actionBarConfig"
    (actionClick)="onClickActionBar($event)"/>
</div>
<div class="content">
  <inf-details [model]="model" [data]="entity"></inf-details>
</div>

<inf-dialog #dialogDelete
            [type]="dialogType.confirm"
            [title]="'i18n.dialog.dialog-delete-title'|translate"
            [confirmText]="{yes: 'i18n.dialog.delete', no: 'i18n.dialog.cancel'}" (action)="onActionDialogDelete($event)">
  {{ "i18n.dialog.text-confirm-delete" | translate }}
</inf-dialog>
